import _sfc_main from "./Language.vue2.mjs";
import "./Language.vue3.mjs";
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.languageConfig.visible ? _c(_setup.IconButton, { attrs: { "title": _setup.title, "layout": _setup.IconButtonLayout.HORIZONTAL, "icon": _setup.LanguageIcon }, on: { "click-icon": _setup.handleChange } }) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const LanguageIcon = __component__.exports;
export {
  LanguageIcon as default
};
